import * as React from "react";
import Select from "react-select";
import usePromise from "../hooks/usePromise";
import {
  getCommissionOrgConfig,
  updateCommissionOrgConfig,
} from "../../libs/commission_calculator";
import { DAYS_LONG } from "../../constants";
import ModernCard from "../core/ModernCard";
import { useCallback, useContext, useState } from "react";
import { RailsUserContext } from "../../libs/user_context";
import TextField from "../core/TextField";
import Button from "../core/Button";
import TextInputWithButton from "../core/TextInputWithButton";
import { toast } from "../../utils";

const DEADLINE_WEEK_OPTS = [
  { label: "Last", value: "last_week" },
  { label: "Second To Last", value: "second_to_last_week" },
];

const DEADLINE_DAY_OPTS = DAYS_LONG.map((d, i) => ({ label: d, value: i }));

function CommissionOrgConfig({ config, configPromise }) {
  const { user: currentUser } = useContext(RailsUserContext);

  const { setResult: setConfig, loading } = configPromise;

  const [financeEmail, setFinanceEmail] = useState(config.financeEmail);

  const updateConfig = useCallback(
    updateAttrs => {
      const newConfig = { ...config, ...updateAttrs };
      setConfig(newConfig);
      return updateCommissionOrgConfig(config.organization.id, newConfig);
    },
    [config, setConfig]
  );

  let deadlineWeekValue, deadlineDayValue;
  if (config && config.deadlineWeek) {
    deadlineWeekValue = DEADLINE_WEEK_OPTS.find(
      opt => opt.value === config.deadlineWeek
    );
  }

  // have to do a typeof check here in case deadlineDay is int zero
  if (config && typeof config.deadlineDay === "number") {
    deadlineDayValue = DEADLINE_DAY_OPTS.find(
      opt => opt.value === config.deadlineDay
    );
  }

  return (
    <ModernCard title="Settings" ta="left" m="0px">
      <h4>Due Date</h4>
      <p>Commissions are due on...</p>
      <Select
        options={DEADLINE_WEEK_OPTS}
        style={{ minWidth: "300px" }}
        isLoading={loading}
        value={deadlineWeekValue}
        onChange={(opt: ISelectOption) =>
          updateConfig({ deadlineWeek: opt.value })
        }
        clearable={false}
      />
      <Select
        options={DEADLINE_DAY_OPTS}
        style={{ minWidth: "300px" }}
        isLoading={loading}
        value={deadlineDayValue}
        onChange={(opt: ISelectOption) =>
          updateConfig({ deadlineDay: opt.value })
        }
        clearable={false}
      />
      {(currentUser.isOwner || currentUser.isSalesManager) && (
        <p>
          We will send you an email reminder 72 hours before your set due date.
        </p>
      )}
      <hr />
      <h4>Finance Contact</h4>
      <p>
        Set the email we will use to send commissions to your finance
        department:
      </p>

      <TextInputWithButton
        onChange={e => setFinanceEmail(e.target.value)}
        value={financeEmail}
        onButtonClick={() =>
          updateConfig({ financeEmail })
            .then(() => toast.success("Updated finance email"))
            .catch(e => {
              toast.error("Error updating finance email");
              throw e;
            })
        }
        buttonText="Update"
      />
    </ModernCard>
  );
}

export default CommissionOrgConfig;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionOrgConfig.tsx